import VideocamIcon from '@mui/icons-material/Videocam';

import { message } from '~helper/_common';

import { LabeledElement } from '~components/molecules/LabeledElement';

export type ClipsLabelProps = {
    children: React.ReactElement | number | string;
    className?: string;
    loading?: boolean;
    'data-test'?: string;
}

export const ClipsLabel: React.FC<ClipsLabelProps> = ({
    'data-test': dataTest = 'clipsLabel',
    ...props
}) => {
    return (
        <LabeledElement
            { ...props }
            label={ message('dataTile.common.clips') }
            labelIcon={ <VideocamIcon /> }
            data-test={ dataTest } />
    );
};
